module.exports = __webpack_public_path__ + "static/media/wz.f3861915.png";